export const gluteProduct = {
  name: 'Glute Lab: El Código del Crecimiento',
  id: 'glute-lab-21',
  guidePrice: 6.39,
  bundlePrice: 27.0,
  currency: 'USD',
  guideCheckoutUrl: 'https://jseefect.com/cart/47031041163463:1',
  /** TODO: reemplazar por tu enlace real de contacto (WhatsApp, Instagram, Calendly o correo). */
  consultingUrl: 'mailto:hola@glutelab.com?subject=Asesor%C3%ADa%201-a-1%20Glute%20Lab',
}

export const gluteImages = {
  ipad: 'https://cdn.magicpatterns.com/patterns/generated-images/04a04636-2849-41ca-b452-d7177703bd86.jpg',
  training:
    'https://cdn.magicpatterns.com/patterns/generated-images/070e50e0-3cc1-4857-8d8f-d0ef4549b4b8.jpg',
  coach: 'https://cdn.magicpatterns.com/patterns/generated-images/d96d73aa-7be4-4c61-9d2c-bba176e15811.jpg',
  mirror: 'https://cdn.magicpatterns.com/uploads/5RakEeQFy628WKjdua9GY1/heylloyd-image-1787261642859.png',
  cover: 'https://cdn.magicpatterns.com/patterns/generated-images/b26dbea0-92d5-4e69-8bc1-1b4e29727d88.jpg',
}

export const heroManifesto = {
  lead: 'Quizás no naciste con los glúteos que querías…',
  bridge: 'Pero eso no significa que tengas que conformarte.',
  claims: ['Puedes construirlos.', 'Puedes transformarlos.'],
}

export const gluteFailedAttempts = [
  'Las rutinas de 100 repeticiones con bandas elásticas solo generan fatiga, no crecimiento real.',
  'Hacer sentadillas pesadas sin activar el glúteo primero solo ensancha tus muslos.',
  'Seguir rutinas de influencers genéricas ignora que tu músculo está "dormido" y no responde a estímulos normales.',
  'El exceso de cardio está consumiendo el poco tono muscular que logras construir.',
]

export const gluteDeliverables = [
  {
    title: 'La Guía Digital "Glute Lab: El Código del Crecimiento"',
    text: 'El manual completo en PDF, con el sistema explicado de principio a fin.',
    featured: true,
  },
  {
    title: 'El Protocolo "Unlock" de 5 minutos',
    text: 'La secuencia de pre-activación para usar antes de cada rutina.',
    featured: false,
  },
  {
    title: 'Plan Maestro de Rescate de 21 días',
    text: 'Calendario paso a paso: qué hacer cada día, sin improvisar.',
    featured: false,
  },
  {
    title: 'Los 4 ejercicios "Elite"',
    text: 'La lista corta de movimientos que realmente generan volumen.',
    featured: false,
  },
  {
    title: 'Guía de Nutrición Anti-Flacidez',
    text: 'Qué comer para reparar y sostener el tejido muscular nuevo.',
    featured: false,
  },
]

export const consultingPitch = {
  title: '¿Prefieres que revisemos tu caso en persona?',
  text: 'Si quieres una asesoría uno a uno para ajustar el método a tu cuerpo, tu horario y tu equipo, escríbeme y lo vemos juntos.',
  cta: 'Contáctame si deseas una asesoría uno a uno',
}

export const auditBenefits = [
  'Revisamos en vivo tu técnica y tu nivel real de activación.',
  'Ajustamos el Plan de 21 Días a tu horario, tu equipo y tu punto de partida.',
  'Sales con las 3 correcciones exactas que desbloquean tu crecimiento.',
]

export const gluteProblemPoints = [
  {
    icon: 'sofa',
    title: 'Glúteo apagado',
    text: 'Horas sentada desconectaron la señal entre tu cerebro y el músculo: entra en amnesia glútea.',
  },
  {
    icon: 'thief',
    title: 'Cuádriceps ladrón',
    text: 'Al no responder el glúteo, el muslo se roba el estímulo y es lo único que crece.',
  },
  {
    icon: 'pain',
    title: 'Dolor mal ubicado',
    text: 'Arden las rodillas y la espalda baja compensa, mientras el glúteo no siente nada.',
  },
  {
    icon: 'flat',
    title: 'Cero cambio visual',
    text: 'Entrenas duro cada semana y de perfil el espejo se ve exactamente igual.',
  },
]

export const gluteForYou = [
  'Mujeres que ya entrenan pero no ven cambios visuales en sus glúteos.',
  'Mujeres que sienten que sus piernas crecen demasiado pero sus glúteos no.',
  'Aquellas que sufren de dolor de espalda baja al hacer ejercicios de pierna.',
  'Latinas en USA que buscan resultados estéticos reales en tiempo récord.',
]

export const gluteNotForYou = [
  'Personas que buscan una solución mágica o cirugía sin esfuerzo.',
  'Fisicoculturistas de élite que ya dominan su conexión mente-músculo.',
  'Personas que no están dispuestas a dedicar 15-20 minutos a seguir el plan.',
]

export const gluteSteps = [
  {
    title: 'Test de Activación',
    text: 'Mide en minutos qué tan "dormidos" están tus glúteos y desde dónde parte tu plan.',
  },
  {
    title: 'Protocolo "Unlock"',
    text: 'Aplica la secuencia de 5 minutos antes de cada sesión para encender la señal correcta.',
  },
  {
    title: 'Plan de 21 Días',
    text: 'Entrena con las pausas isométricas de 3 segundos que fuerzan el crecimiento del músculo.',
  },
]

export const gluteTestimonials = [
  {
    quote:
      'Llevaba dos años entrenando piernas y nada cambiaba. Con el protocolo de activación sentí el glúteo trabajando desde la primera sesión. A las tres semanas mis jeans ya me quedaban distinto.',
    name: 'Mariana R.',
    detail: 'Houston, TX · 34 años',
    highlight: '3 semanas',
  },
  {
    quote:
      'Lo que más me sirvió fueron las pausas de 3 segundos. Bajé el peso, hice menos repeticiones y por fin dejó de dolerme la espalda baja al día siguiente.',
    name: 'Kimberly A.',
    detail: 'Orlando, FL · 28 años',
    highlight: 'Sin dolor lumbar',
  },
  {
    quote:
      'Entreno en casa con una banda y dos mancuernas. Pensé que necesitaba gimnasio, pero el plan de 21 días está armado para que no tengas excusa. Mi esposo fue el primero en notar el cambio.',
    name: 'Doris M.',
    detail: 'Los Ángeles, CA · 41 años',
    highlight: 'Entrena en casa',
  },
]

export const consultingTestimonial = {
  quote:
    'La asesoría uno a uno fue excelente. En 30 minutos me corrigió la postura, me ajustó el plan a mis días de trabajo y salí sabiendo exactamente qué hacer. Valió más que meses de rutinas por internet.',
  name: 'Vanessa T.',
  detail: 'Phoenix, AZ · asesoría 1-a-1',
}

export const gluteFaqs = [
  {
    question: '¿Necesito pesas pesadas?',
    answer: 'No. Puedes empezar con peso corporal o implementos caseros.',
  },
  {
    question: '¿Cuánto tiempo al día requiere?',
    answer:
      'El protocolo de activación solo toma 5 minutos; la rutina completa unos 20 a 30 minutos.',
  },
  {
    question: '¿Puedo recibir acompañamiento personalizado?',
    answer:
      'Sí. La guía funciona por sí sola, pero si quieres una asesoría uno a uno para adaptar el plan a tu caso, puedes contactarme desde el enlace al final de la página.',
  },
  {
    question: '¿Es un pago único?',
    answer: 'Sí. Pagas una sola vez y el material es tuyo para siempre.',
  },
  {
    question: '¿Recibo algo por correo físico?',
    answer: 'No. Es un producto digital de acceso inmediato tras la compra.',
  },
  {
    question: '¿Qué pasa si no veo cambios?',
    answer:
      'El método está diseñado para mejorar la conexión neuromuscular; si lo sigues, sentirás la diferencia desde la primera sesión.',
  },
]
